"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StorefrontSectionMarkerContext = _interopRequireDefault(require("../../context/StorefrontSectionMarkerContext"));

var StorefrontSectionMarker = function StorefrontSectionMarker(_ref) {
  var children = _ref.children,
      name = _ref.name,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? true : _ref$active;

  var _useContext = (0, _react.useContext)(_StorefrontSectionMarkerContext.default),
      onMount = _useContext.onMount;

  (0, _react.useEffect)(function () {
    if (active) {
      onMount(name);
    }
  }, [active, name, onMount]);
  return children || null;
};

StorefrontSectionMarker.propTypes = {
  active: _propTypes.default.bool,
  children: _propTypes.default.node,
  name: _propTypes.default.string.isRequired
};
var _default = StorefrontSectionMarker;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/StorefrontSectionMarker.js
// module id = 441
// module chunks = 209 210 211 212